export const guideToc = [
  { id: "prepare", label: "提交前先准备什么" },
  { id: "steps", label: "三步完成投递" },
  { id: "safety", label: "如何保护你自己" },
  { id: "by-type", label: "不同线索的整理建议" },
  { id: "myths", label: "五个常见误区" },
];

export const prepChecklist = [
  {
    title: "先分清事实的边界",
    desc: "哪些是你亲眼所见、亲手经手，哪些是听来的转述。在提交时如实标注，能大幅提高核验效率，也能避免你无意中为不准确的内容背书。",
  },
  {
    title: "保留原始载体，而不是复印件",
    desc: "原始文件、原始邮件、导出记录、原设备上的聊天记录，价值远高于截图与二次转述。能说明「怎么拿到的」和「谁经手过」，比文件本身更关键。",
  },
  {
    title: "把时间线写出来",
    desc: "一件事从什么时候开始、经过哪些节点、谁在什么时候做了什么决定。时间线是最容易被交叉验证的部分，也最容易暴露矛盾。",
  },
  {
    title: "想清楚你能承受的边界",
    desc: "你愿意公开到什么程度、哪些内容绝对不能出现、如果单位追查你希望我们怎么应对。这些边界请在第一次沟通时就说清楚，我们会按它执行。",
  },
];

export const guideSteps = [
  {
    step: "01",
    title: "写下你知道的部分",
    desc: "不必写成正式报告。用你自己的语言把事情的来龙去脉讲清楚，比堆砌文件更有用。可以先只写三五百字，我们会回问你缺什么。",
    tip: "建议包含：时间、地点、涉及的对象、你如何得知、你手上有哪些材料。",
  },
  {
    step: "02",
    title: "提交并约定沟通方式",
    desc: "在提交通道填写线索摘要与联系方式。你可以只留一个一次性邮箱，也可以要求我们只用约定的方式联系你，其他渠道一律不回应。",
    tip: "如果你暂时不想交材料，可以在详情里写明「先沟通」，我们会先联系你。",
  },
  {
    step: "03",
    title: "在核实中补充与确认",
    desc: "核实时我们可能会反复向你确认细节。这个过程可能持续几天到几周。在最终呈现之前，你有权随时叫停并要求删除材料。",
    tip: "我们不会在你不知情的情况下发布与你直接相关的内容。",
  },
];

export const safetyTips = [
  {
    icon: "ri-computer-line",
    title: "不要用单位设备与网络",
    desc: "公司电脑、办公网络与内部系统日志可能留存你的操作记录。请使用个人设备、个人网络，必要时使用公共网络环境操作。",
  },
  {
    icon: "ri-mail-check-line",
    title: "用一个不绑定真实身份的邮箱",
    desc: "临时邮箱或与生活账号完全隔离的邮箱更适合建立联系。不要用绑定实名、绑定手机号的常用邮箱直接投递敏感材料。",
  },
  {
    icon: "ri-file-shred-line",
    title: "注意文件的隐藏信息",
    desc: "文档属性里可能带有作者、单位、修订记录。若你不确定如何清除，可以在提交时说明来源，由我们在脱敏环节统一处理。",
  },
  {
    icon: "ri-user-voice-line",
    title: "不要在同事间扩散",
    desc: "很多身份暴露并非来自技术溯源，而是来自人际传播。尽量把知悉范围控制在你自己与我们的沟通之内。",
  },
  {
    icon: "ri-history-line",
    title: "保留你自己的一份记录",
    desc: "在安全的地方留一份材料的备份与提交时间记录。这既是你的凭据，也能在需要核对版本时派上用场。",
  },
  {
    icon: "ri-scales-3-line",
    title: "先弄清你可能承担的责任",
    desc: "保密协议、劳动合同与当地法律可能限制你对外提供材料。若线索涉及重大公共利益，建议先咨询专业人士，再决定是否提交。",
  },
];

export const typeAdvice = [
  {
    label: "文件与合同类",
    title: "按「文件 + 背景」成组提交",
    desc: "单独一份合同往往说明不了什么。把合同、对应的审批记录、实际执行结果放在一起，矛盾点自然会浮现。请注明每份文件的获取途径。",
    icon: "ri-file-shield-2-line",
  },
  {
    label: "数据与报表类",
    title: "交代口径与改动痕迹",
    desc: "同一组数字可能有不同口径。请说明数据来源系统、导出时间，以及你判断「被修改过」的依据，比如版本差异或指标异常。",
    icon: "ri-bar-chart-grouped-line",
  },
  {
    label: "人证与亲历类",
    title: "把场景细节写具体",
    desc: "时间、地点、在场的人、原话、当时的职务与流程。细节越具体越容易被印证，也越难被一句「记错了」带过。",
    icon: "ri-user-voice-line",
  },
  {
    label: "现场与影像类",
    title: "保留原始文件与拍摄信息",
    desc: "不要只发压缩后的图片。原始照片与视频通常带有拍摄时间与设备信息，是判断真实性的重要依据。同时请说明拍摄时的处境。",
    icon: "ri-camera-lens-line",
  },
];

export const myths = [
  {
    claim: "材料给得越多越安全",
    truth:
      "恰恰相反。一次性交出全部材料，既增加了你在传递过程中的暴露风险，也可能包含与你无关的敏感信息。按核实进度分批提供，通常更稳妥。",
  },
  {
    claim: "匿名就等于绝对安全",
    truth:
      "匿名能降低风险，但不能消除风险。网络层面的日志、单位内部的访问记录、人际传播，都可能成为溯源途径。匿名只是措施之一。",
  },
  {
    claim: "只有惊天大案才值得投",
    truth:
      "日常性的程序违规、反复被压下的投诉、长期存在的小问题，往往更能反映制度性的缺口。公共价值不取决于事件的大小。",
  },
  {
    claim: "提交了就必须公开",
    truth:
      "不是。很多线索在核实后没有被呈现，可能是因为证据不足、可能因为公开会伤害无辜第三方，也可能因为你中途决定撤回。这些我们都接受。",
  },
  {
    claim: "先发到网上更快",
    truth:
      "未经核实的公开传播，容易让关键证据被对方提前处理，也可能让提供者陷入被动。先私下核实，再决定以什么方式呈现，通常更有效。",
  },
];